/** Helper functions that loads a translation key with the current host if there is one, else just loads the message from `baseKey` */
export const useTranslateWithHost = () => {
  const { t, te } = useI18n();
  const host = useCurrentHost();

  const translateWithHost = (key: string, _params?: Parameters<typeof t>) => {
    if (!key) {
      return "";
    }

    const hostKey = `${key}-${host.value}`;
    return te(hostKey) ? t(hostKey) : t(key);
  };

  return translateWithHost;
};
